import { FC } from 'react';
import { useTheme } from 'styled-components/macro';

import Icon, { IconPropsT } from './Icon';

const PhotoCameraIcon: FC<IconPropsT> = props => {
  /**
   * Hooks
   */
  const theme = useTheme();

  return (
    <Icon {...props}>
      <svg
        height="20"
        width="20"
        viewBox="0 0 20 20"
        fill={theme.colors.primary.variant8}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M10.021 14.583q1.583 0 2.677-1.093 1.094-1.094 1.094-2.678 0-1.583-1.094-2.677-1.094-1.093-2.677-1.093-1.604 0-2.688 1.093Q6.25 9.229 6.25 10.812q0 1.584 1.083 2.678 1.084 1.093 2.688 1.093Zm0-1.75q-.875 0-1.448-.583T8 10.812q0-.854.573-1.437.573-.583 1.448-.583.854 0 1.437.583.584.583.584 1.437 0 .855-.584 1.438-.583.583-1.437.583ZM3.417 17.5q-.729 0-1.24-.51-.51-.511-.51-1.24V5.896q0-.729.51-1.24.511-.51 1.24-.51h2.541L7.479 2.5h5.042l1.541 1.646h2.521q.729 0 1.24.51.51.511.51 1.24v9.854q0 .729-.51 1.24-.511.51-1.24.51Zm13.166-1.75V5.896h-3.271L11.771 4.25H8.25L6.708 5.896H3.417v9.854ZM10 10.812Z" />
      </svg>
    </Icon>
  );
};

export default PhotoCameraIcon;
